import { ShieldCheck } from 'lucide-react';
import walletData from '../../../../data/wallet/walletData.json';

const WalletCommissionInfoStrip = () => {
  const steps = walletData.commissionSystemSteps || [];

  return (
    <div className="bg-white rounded-3xl border border-slate-200/80 p-4 sm:p-5 lg:p-6 shadow-sm">
      <h3 className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-3 flex items-center gap-1.5">
        <ShieldCheck size={14} className="text-[#067978]" />
        <span>Commission &amp; Settlement System</span>
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 sm:gap-4 text-xs">
        {steps.map((item) => (
          <div key={item.step} className="p-3.5 rounded-2xl bg-slate-50 border border-slate-100 flex gap-3 items-start">
            <div className="w-7 h-7 rounded-xl bg-teal-50 text-[#067978] flex items-center justify-center shrink-0 font-bold">
              {item.step}
            </div>
            <div>
              <strong className="text-slate-800 block mb-0.5">{item.title}</strong>
              <span className="text-slate-500 leading-relaxed">{item.description}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WalletCommissionInfoStrip;
